import { useCallback, useEffect, useRef } from 'react';
import { isConfigFlagEnabled } from '../config';
import { scrollToBottom } from '../utils/scrollUtils';
export function useScrollLocking(items) {
    const elementRef = useRef();
    const isScrollLocked = useRef(false); // whether the user has scrolled up from the bottom and therefore is "locked" and will not auto-scroll on new items
    const onScroll = useCallback((event) => {
        const isScrolledToBottom = event.currentTarget.scrollHeight - event.currentTarget.scrollTop === event.currentTarget.clientHeight;
        isScrollLocked.current = !isScrolledToBottom;
    }, []);
    const maybeScrollToBottom = useCallback(() => {
        if (elementRef.current) {
            scrollToBottom(elementRef.current);
        }
    }, []);
    // When items array changes (new items were added), scroll to the bottom if the user hasn't manually scrolled up from the bottom.
    useEffect(() => {
        if (!isConfigFlagEnabled('scrollLocking') || !isScrollLocked.current) {
            maybeScrollToBottom();
        }
    }, [items, maybeScrollToBottom]);
    const setScrollLockingElementRef = useCallback((element) => {
        elementRef.current = element;
    }, []);
    return [setScrollLockingElementRef, onScroll];
}
